import { render } from "./ShowGames.vue?vue&type=template&id=776d7f08"
import script from "./ShowGames.vue?vue&type=script&lang=ts"
export * from "./ShowGames.vue?vue&type=script&lang=ts"

import "./ShowGames.vue?vue&type=style&index=0&id=776d7f08&lang=css"
script.render = render

export default script